import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
import { Button } from './ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const AddToNotepadDialog = ({ open, onOpenChange, product, onAdd }) => {
  const [quantity, setQuantity] = useState(1);

  const handleIncrement = () => {
    if (quantity < 999) setQuantity(quantity + 1);
  };

  const handleDecrement = () => {
    if (quantity > 1) setQuantity(quantity - 1);
  };

  const handleAdd = () => {
    onAdd(quantity);
    setQuantity(1); // Reset for next time
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[425px]">
        <DialogHeader>
          <DialogTitle>Zum Merkzettel hinzufügen</DialogTitle>
          <DialogDescription>
            Wählen Sie die Menge für "{product?.name}"
          </DialogDescription>
        </DialogHeader>
        
        <div className="flex items-center justify-center gap-4 py-6">
          <Button
            variant="outline"
            size="icon"
            onClick={handleDecrement}
            disabled={quantity <= 1}
            className="rounded-none border-[#C4A084] text-[#5D4E3C] hover:bg-[#F5EDE4]"
          >
            <Minus className="h-4 w-4" />
          </Button>
          
          <div className="text-center">
            <input
              type="number"
              value={quantity}
              onChange={(e) => {
                const val = parseInt(e.target.value) || 1;
                setQuantity(Math.max(1, Math.min(999, val)));
              }}
              className="w-20 text-center text-2xl font-bold border-b-2 border-[#C4A084] focus:border-[#AF9774] outline-none"
              min="1"
              max="999"
            />
            <p className="text-sm text-[#8B7355] mt-1">Stück</p>
          </div>
          
          <Button
            variant="outline"
            size="icon"
            onClick={handleIncrement}
            disabled={quantity >= 999}
            className="rounded-none border-[#C4A084] text-[#5D4E3C] hover:bg-[#F5EDE4]"
          >
            <Plus className="h-4 w-4" />
          </Button>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)} className="rounded-none border-[#C4A084] text-[#5D4E3C] hover:bg-[#F5EDE4]">
            Abbrechen
          </Button>
          <Button onClick={handleAdd} className="rounded-none text-white" >
            Hinzufügen
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default AddToNotepadDialog;
